import { Injectable } from '@angular/core';
import { CacheService } from './cache.service';
import { UserSetting } from '../models/UserSetting';
import { HttpService } from './http.service';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import {Customer} from '../models/Customer';
import {UserService} from './user.service';
import {HttpResponse} from '@angular/common/http';
import {mapTo, mergeMap, tap} from 'rxjs/operators';

@Injectable()
export class CustomerService {

    currentCustomer: Customer;

    constructor(
        private httpService: HttpService,
        private cacheService: CacheService,
        private userService: UserService
    ) { }


    getCustomerSettings(customerId: number, skipCache: boolean = false): Observable<Array<UserSetting>> {
        if (!skipCache && this.cacheService.hasItem('currentCustomerSettingsRaw', 0)) {
            return of(this.cacheService.getItem('currentCustomerSettingsRaw', 0));
        } else {
            return this.fetchCustomerSettings(customerId);
        }
    }

    private fetchCustomerSettings(customerId: number): Observable<Array<UserSetting>> {
        return this.httpService.get<Array<UserSetting>>(environment.apiV1BaseUrl + `/accounts/customers/${customerId}/customer-settings`).pipe(
            tap((customerSettings) => this.cacheService.setItem('currentCustomerSettingsRaw', 0, customerSettings))
        );

    }

    getCustomer(skipCache: boolean = false): Observable<Customer> {
        if (!skipCache && this.cacheService.hasItem('currentCustomer', 0)) {
            return of(this.cacheService.getItem('currentCustomer', 0));
        } else {
            return this.fetchCustomer().pipe(
                tap((customer: Customer) => {
                    this.currentCustomer = customer;
                })
            );
        }

    }

    private fetchCustomer(): Observable<Customer> {
        return this.httpService.get<Customer>(environment.apiV1BaseUrl + '/accounts/customer').pipe(
            tap((customer) => this.cacheService.setItem('currentCustomer', 0, customer))
        );
    }


    updateCurrentCustomerSetting(settingKey: string, setting: UserSetting, customerId: number): Observable<boolean> {

        return this.httpService.put(environment.apiV1BaseUrl + `/accounts/customers/${customerId}/customer-settings/` + settingKey, setting, { observe: 'response' }).pipe(
            tap((res: HttpResponse<any>) => {
                if (res.status !== 200 && res.status !== 201) {
                    throw new Error('Update user settings failed');
                }
            }),
            mergeMap(() => {
                // Trigger refresh of setting streams and currentUser
                return this.getCustomer(true);
            }),
            mergeMap(() => {
                // Trigger refresh of current User's active settings
                return this.userService.getCurrentUser(true);
            }),
            mapTo(true)
        );
    }


}
